/**
 * @generated SignedSource<<be2a8efe4475c4123ed795e715e4924d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WANoteExistingSelectNote_widget$data = {
  readonly height: number;
  readonly note: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
  readonly " $fragmentType": "WANoteExistingSelectNote_widget";
};
export type WANoteExistingSelectNote_widget$key = {
  readonly " $data"?: WANoteExistingSelectNote_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WANoteExistingSelectNote_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WANoteExistingSelectNote_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNote_widgetNote"
    }
  ],
  "type": "WidgetNote",
  "abstractKey": null
};

(node as any).hash = "6920049c44940c81a5e49796f38ab111";

export default node;
